import { ConfigMaxSetAttrAuthors } from '../models/configmaxsetattrauthors';
export class ConfigMaxSetAttributes {
    public id: number;
    public cmSetCategoryId: number;
    public attrHeaderId: number;
    public attrKeyId: number;
    public attrValue: String
    public attrTargetValue: String;
    public internal: boolean
    public statusId: number;
    public testPlan: String;
    public pmt: String;
    public description: String;
    public lastUpdate: Date;
    public updatedBy: String;
    public productId: number;
    public versionId: number;
    public categoryId: number;
    public subcategoryId: number;
    public keyname: String;

    public approvals: ConfigMaxSetAttrAuthors[];
}



// WEBPACK FOOTER //
// ./src/app/models/configmaxsetattributes.ts